"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'file.clipboard.images_pasted': '{count} obraz(y) wklejony(e) ze schowka',
};
